import { WalletHistoryProps, defaults } from '@/components/ui/WalletHistory';
import { gravComponentSchema } from '../deep-form-grav';


const { s, l, bl, c, v, src, h, toExport } = gravComponentSchema<WalletHistoryProps>({
  title: 'Wallet History',
  link: 'https://www.notion.so/mlmsoft/WalletHistory-caefe9f6a0194ac98f242877a59f7256',
  text: text(),
},
  defaults,
  // Migrate old single number wallet value to array format
  (props) => {
    if (typeof props.wallet === 'number') {
      return { ...props, wallet: [props.wallet] };
    }
    return props;
  },
);

export default toExport;

s.add('wallet').input('dlist').data(
  s.spawn<number>().as(l.clone('walletId'))
    .title('Wallet')
    .init(() => 0).mandatory().item(),
)
  .col(8).title('Wallet(s)')
  .desc('Select one or multiple wallets. If multiple selected, a wallet filter will be displayed');

s.add('headerClass').input('mdiColor')
  .title('Widget header color').col(3);

s.add('title').input('text').title('Title').props({ clearable: true }).col(5);


s.add('start').input('date').title('Start date').col(3);
s.add('end').input('date').title('End date').col(3);


s.add('operationTypes').input('dlist').data(

  // s.spawn<number>().input('dictionary').dataAsync(src.walletOperations)
  //   .init(() => 0).mandatory().item(),

  s.spawn<number>().as(bl.clone('number'))
    .title('ID of operation')
    .init(() => 0).props({ hideDetails: true }).mandatory().item(),


)
  .col(6).title('Operation types');

s.add('walletCountries').as(l.clone('walletCountries'))
  .title('Wallet depending on country')
  .desc('Depending on country setting in users profile make this widget to use corresponding wallet(s). You can specify one or multiple wallets per country.');

s.add('rowColorPositive').input('color')
  .title('Row color for positive amounts').col(3);

s.add('rowColorNegative').input('color')
  .title('Row color for negative amounts').col(3);

s.add('amountColorPositive').input('color')
  .title('Text color for positive amounts').col(3);

s.add('amountColorNegative').input('color')
  .title('Text color for negative amounts').col(3);


function text() {
  return `
<b>Wallet History</b>
`;
}
